import SmartAutocompleteBase from "../assets/SmartAutocompleteBase";


class ProductsSmartAutocomplete extends SmartAutocompleteBase {


}

export default ProductsSmartAutocomplete